

import React from 'react'
import Wrapper from "../../components/helpers/Wrapper";

const MarketShareIcon = (props) => {
  return (
    <Wrapper>
      <svg xmlns="http://www.w3.org/2000/svg" className={props.className} width="19" height="19" viewBox="0 0 19 19" fill="none">
        <path d="M9.5 18.5C14.4706 18.5 18.5 14.4706 18.5 9.5C18.5 4.52944 14.4706 0.5 9.5 0.5C4.52944 0.5 0.5 4.52944 0.5 9.5C0.5 14.4706 4.52944 18.5 9.5 18.5Z" stroke="#9747FF" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M9.5 0.5V9.5H18.5" stroke="#9747FF" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M9.50027 9.5L2.03027 14.441" stroke="#9747FF" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M9.5 2.25952H14.8595" stroke="#9747FF" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M9.5 4.84253H17.1005" stroke="#9747FF" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M9.5 7.4209H18.194" stroke="#9747FF" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

    </Wrapper>
  )
}

export default MarketShareIcon

